
import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from "vue-property-decorator";
import {
  ApplicationViewModel,
  PaymentMethodWithDescription,
  PaymentViewModel,
  RequirementsClient,
  StateFeeRequirementViewModel,
} from "@/api-client";
import {
  PaymentDetailsProps,
  StateFeeSeafarerProps
} from "@/features/applications/components/requirements/stateFee/StateFeeComponentProps";
import TransferPaymentInfo from "@/features/applications/components/requirements/stateFee/TransferPaymentInfo.vue";
import OnSitePaymentInfo from "@/features/applications/components/requirements/stateFee/OnSitePaymentInfo.vue";
import PaymentDetails from "@/features/applications/components/requirements/stateFee/PaymentDetails.vue";
import StateFeeInfoCard from "@/features/applications/components/requirements/stateFee/StateFeeInfoCard.vue";
import SwedbankBankLinkPaymentInfo from "@/features/applications/components/requirements/stateFee/SwedbankBankLinkPaymentInfo.vue";
import ExemptionPaymentInfo from "@/features/applications/components/requirements/stateFee/ExemptionPaymentInfo.vue";
import { CreateSwedbankBankLinkRequest } from '@/api-client';
import { ICreateSwedbankBankLinkRequest } from '@/api-client';
import {settings} from "@/main"

enum PaymentOption {
  BankLink = 1,
  Transfer,
  OnSite,
  Exemption
}

@Component({
  components: {
    PaymentDetails,
    TransferPaymentInfo,
    ExemptionPaymentInfo,
    SwedbankBankLinkPaymentInfo,
    StateFeeInfoCard,
    OnSitePaymentInfo,
  },
})
export default class StateFeeSeafarer extends Vue {
  @Prop({required: true})
  props!: StateFeeSeafarerProps;
  
  application!: ApplicationViewModel; // TODO: Constrain this.
  requirement!: StateFeeRequirementViewModel;
  requirementValue!: PaymentViewModel | null;

  paymentOptions: any = PaymentOption;
  chosenPaymentOption: PaymentOption | null = null;
  paymentMethods: PaymentMethodWithDescription[] = [];

  paymentDetailsProps: PaymentDetailsProps | null = null;
  
  chosenBankLinkOption = "";
  chosenBic = "";
  showSuccessMessage = false;

  async created() {
    this.application = this.props.application;
    this.requirement = this.props.requirement;
    this.requirementValue = this.props.requirementValue;
    this.paymentDetailsProps = new PaymentDetailsProps(this.requirementValue!, this.application, this.requirement, false);

    if (this.$route.params.successMessage) 
      this.showSuccessMessage = true;
    
    this.paymentMethods = await new RequirementsClient().paymentMethods(this.application.id, this.requirement.id);
    
    if (this.requirementValue != null)
      this.chosenPaymentOption = this.paymentOptions[this.requirementValue!.chosenMethod.paymentMethod]
  }

  get paymentMade() {
    return this.requirementValue?.isConfirmed;
  }

  get paymentDetailsHeading() {
    return this.paymentMade ? this.$ls.Applications_Requirements_StateFee_Heading_StateFeeChosen : this.$ls.Applications_Requirements_StateFee_Heading_ChoosePaymentMethod;
  }

  async choosePaymentMethod(paymentOption: PaymentOption) {
    const paymentMethodModel = this.paymentMethods.filter(x => x.paymentMethod === this.paymentOptions[paymentOption])[0];

    await new RequirementsClient()
        .choosePaymentMethod(paymentMethodModel.paymentMethod, this.application.id, this.requirement.id)
        .then(() => {
          this.$emit("application-changed");
          this.chosenPaymentOption = paymentOption;
        });
  }
  
async initiateSwedbankBankLinkPayment() {
    const cancelUrl = settings.misApiBaseUrl + '/payments/swedbank-banklink-cancel/' + this.application.id + '/' + this.requirement.id;
    const returnUrl = settings.misApiBaseUrl + '/payments/swedbank-banklink-return/' + this.application.id + '/' + this.requirement.id;
    const requestModel: ICreateSwedbankBankLinkRequest = {bic: this.chosenBic, cancelUrl: cancelUrl, returnUrl: returnUrl };
    await new RequirementsClient()
      .createSwedbankBankLink(new CreateSwedbankBankLinkRequest(requestModel), this.application.id, this.requirement.id)
        .then(
            result => {
                const form = document.createElement("form");
                form.setAttribute("method", "post");
                form.setAttribute("action", result.url);
                for(const key in result.requestBody) {
                    const input = document.createElement("input");
                    input.setAttribute("name", key.toUpperCase());
                    input.setAttribute("value", (result.requestBody as any)[key]);
                    form.appendChild(input);
                }

                const input = document.createElement("input");
                input.setAttribute("name", "VK_MAC");
                input.setAttribute("value", result.vK_MAC);
                form.appendChild(input);

                document.body.appendChild(form);
                form.submit();

            },
            error => this.$emit("error-happened", error)
        );
  }
}
